import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Injector,
  } from '@angular/core';
  import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterEvent } from '@angular/router';
  
  import { CareMoniSpinnerComponent } from './spinner.component';
  import { FullscreenService } from '@core/services/common';
  
  @Injectable({
    providedIn: 'root',
  })
  export class CareMoniSpinnerService {
    spinner!: ComponentRef<CareMoniSpinnerComponent>;
    spinnerExist = false;
    isFirstTime: boolean = false;
    isFullScreenElementActive: boolean = false;
    private androidBridge = (window as any).AndroidBridge;

    constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
      private appRef: ApplicationRef,
      private injector: Injector,
      private router: Router,
      private fullScreenTracker: FullscreenService,
    ) {
      this.fullScreenTracker.fullscreenState$.subscribe(state => {
        this.isFullScreenElementActive = state.isFullscreen;
      })
     }
  
    show() {
      // Notify Android bridge to show spinner
      if(this.androidBridge && typeof this.androidBridge.onSpinnerAppShow === 'function') {
          this.androidBridge.onSpinnerAppShow(true);
          return
        }
      
      if (!this.spinnerExist) {
        this.spinner = this.componentFactoryResolver
          .resolveComponentFactory(CareMoniSpinnerComponent)
          .create(this.injector);
        this.spinner.instance.isFirstTime = this.isFirstTime;
        this.appRef.attachView(this.spinner.hostView);
        const domElem = (this.spinner.hostView as EmbeddedViewRef<any>)
          .rootNodes[0] as HTMLElement;
      
          if (this.isFullScreenElementActive) {
            const doc = document as any;
            const fullscreenElement = doc.fullscreenElement || doc.webkitFullscreenElement || null;
            if(fullscreenElement) fullscreenElement.appendChild(domElem);
            else document.body.appendChild(domElem);
          } 
          else {
            document.body.appendChild(domElem);
          }
        this.spinnerExist = true;
      }
    }
  
    hide() {
      // Notify Android bridge to hide spinner
      if(this.androidBridge && typeof this.androidBridge.onSpinnerAppShow === 'function') {
          this.androidBridge.onSpinnerAppShow(false);
          return
        }

      if (this.spinnerExist) {
        this.appRef.detachView(this.spinner.hostView);
        this.spinner.destroy();
        this.spinnerExist = false;
      }
    }
  
    trackRouteLoadIndicator() {
      let asyncLoadCount = 0;
  
      this.router.events.subscribe((event): void => {
        if (event instanceof RouteConfigLoadStart) {
          asyncLoadCount++;
        } else if (event instanceof RouteConfigLoadEnd) {
          asyncLoadCount--;
        }
  
        if (!!asyncLoadCount) {
          this.show();
        } else {
          this.hide();
        }
      });
    }
  }
  